var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "frame",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.5604 8.08359H27.5424V16.6539H30.5604V8.08359ZM22.2658 8.04688H19.2479V16.6211H22.2658V8.04688ZM9.44004 0L1.89941 7.14219V32.8578H10.9486V40L18.49 32.8578H24.5252L38.101 20V0H9.44004ZM35.0838 18.5742L29.051 24.2867H23.0166L17.7353 29.2867V24.2867H10.9486V2.85781H35.0838V18.5742Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTw);
export default __webpack_public_path__ + "static/media/tw.a9106d7abadbc86f583bc8362d310c6c.svg";
export { ForwardRef as ReactComponent };